import axios from 'axios';
import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/unwrapApiResponse';

const apiBase = process.env.REACT_APP_API_BASE_URL;

const unwrapPublicResponse = (response) => {
  const body = response.data;

  if (!body?.success) {
    const error = new Error(body?.message || 'Request failed');
    error.errors = body?.errors || [];
    error.status = response.status;
    throw error;
  }

  return body.data;
};

export const submitPartnershipInquiry = async (payload) => {
  const response = await axios.post(`${apiBase}/api/partnership-submissions`, payload);
  return unwrapPublicResponse(response);
};

export const getPartnershipSubmissions = async () => {
  const response = await axiosClient.get('/api/admin/partnership-submissions');
  return unwrapApiResponse(response);
};

export const getPartnershipSubmissionById = async (id) => {
  const response = await axiosClient.get(`/api/admin/partnership-submissions/${id}`);
  return unwrapApiResponse(response);
};

export const deletePartnershipSubmission = async (id) => {
  const response = await axiosClient.delete(`/api/admin/partnership-submissions/${id}`);
  return unwrapApiResponse(response);
};
